const routes = {
  '/': 'Home',
  '/dashboard': 'Dashboard',  
  '/clients': 'Klanten', 
  '/addresses': 'Adressen', 
  '/addresses/view': 'bekijken', 
  '/files': 'Bestanden',
  '/filetype/add': 'toevoegen', 
  '/filetype': 'Bestandstype',
  '/filetype/add': 'toevoegen',
  '/filetype/update': 'bewerken',
  '/filetype/view': 'bekijken',
  '/filemetadatacategory': 'Metadata categorie',
  '/filemetadatacategory/add': 'toevoegen',
  '/filemetadatacategory/update': 'bewerken',
  '/filemetadatacategory/view': 'bekijken',
  '/filemetadatavalue': 'Metadata waarde',
  '/filemetadatavalue/add': 'toevoegen',
  '/filemetadatavalue/update': 'bewerken',
  '/filemetadatavalue/view': 'bekijken',
  '/user': 'Gebruiker',
  '/user/add': 'toevoegen',
  '/user/update': 'bewerken',
  '/user/view': 'bekijken',




};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js